import { ReactNode, useEffect } from 'react';

interface Props {
  children: ReactNode;
}

export function ClientWebStyles(props: Props) {
  useEffect(() => {
    const linkOne = document.createElement('link');
    linkOne.rel = 'preconnect';
    linkOne.href = 'https://fonts.googleapis.com';
    document.head.appendChild(linkOne);

    const linktwo = document.createElement('link');
    linktwo.crossOrigin = 'anonymous';
    linktwo.rel = 'preconnect';
    linktwo.href = 'https://fonts.googleapis.com';
    document.head.appendChild(linktwo);

    const linkthree = document.createElement('link');
    linkthree.rel = 'stylesheet';
    linkthree.href =
      'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap';
    document.head.appendChild(linkthree);

    CSSProperties.forEach(([property, value]) => {
      document.documentElement.style.setProperty(property, value);
    });

    document.body.style = `background-color: #131314; color: whitesmoke`;

    return () => {
      document.head.removeChild(linkOne);
      document.head.removeChild(linktwo);
      document.head.removeChild(linkthree);
    };
  }, []);

  return (
    <div
      style={{
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 400,
      }}
    >
      {props.children}
    </div>
  );
}

const CSSProperties: [string, string][] = [
  ['--list-spacing-bottom', '1rem'],
  ['--list-spacing-top', '1rem'],
  ['--section-background-color', 'transparent'],
  ['--section-margin-block', '1rem'],
  ['--section-margin-inline', '0rem'],
  ['--section-padding-block', '0'],
  ['--section-padding-inline', '0'],
];
